import { BrowserRouter } from 'react-router-dom';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { Portal } from './Portal';

import './main.css';
import ConfirmationBox from './components/ConfirmationBox';
import AlertBar from './components/AlertBar';
import { useEffect, useState } from 'react';
import { DataService } from './services/data-service';
import { TabProvider } from './contexts/TabContext';

function App() {
  const [booted, setBooted] = useState<boolean>(false);
  useEffect(() => {
    DataService.setBaseUrl('https://rental-app-ghbdezdxexa8dkhu.westeurope-01.azurewebsites.net/');
    // DataService.setBaseUrl("https://localhost:7287/");
    setTimeout(() => {
      setBooted(true);
    }, 150);
  }, []);

  if (booted) {
    return (
      <ThemeProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <CssBaseline />
          <BrowserRouter>
            <TabProvider>
              <AlertBar />
              <Portal />
              <ConfirmationBox />
            </TabProvider>
          </BrowserRouter>
          {}
        </LocalizationProvider>
      </ThemeProvider>
    );
  }

  return <></>;
}
export default App;
